import React from 'react';

import { useDispatch } from 'react-redux';
import { scaStartEnrollment } from 'actions';

import { FormattedMessage } from 'react-intl';

import {
  Box,
  Button,
} from '@material-ui/core';

import Main from 'components/templates/Main';
import SCAVerificationDialog from 'components/shared/SCAVerificationDialog';
import SCAInformation from 'components/shared/SCAInformation';

const SCAEnroll = () => {
  const dispatch = useDispatch();

  const handleStart = () => {
    dispatch(scaStartEnrollment({ returnUrl: window.location.href }));
  };

  return (
    <Main title={(
      <FormattedMessage
        id="sca.enrollment.title"
        defaultMessage="SCA Enrollment"
      />
    )}
    >
      <Box p={4}>
        <SCAInformation />

        <Box mt={3}>
          <Button variant="contained" color="primary" onClick={handleStart}>
            Start Verification
          </Button>
        </Box>
      </Box>

      <SCAVerificationDialog />
    </Main>
  );
};

export default SCAEnroll;
